import axios from "axios";

const MEDIUM_URI = process.env.REACT_APP_MEDIUM_RSS_URL || "";

export async function getAllMediumPosts() {
  const response = await axios.get(MEDIUM_URI);
  return response.data;
}
